/** O InboxPage le a conversa aberta de `?c=`; qualquer outro nome abre a primeira da lista. */
export function rotaDaConversa(conversaId: string, mensagemId?: string): string {
  const params = new URLSearchParams({ c: conversaId });
  if (mensagemId !== undefined) params.set('m', mensagemId);
  return `/inbox?${params.toString()}`;
}
